// eslint-disable-next-line spire/fenced-imports
import {
    HasErrorStatusCode as HasErrorStatusCodeFromContentLibrary,
    PageErrorWrapper as PageErrorWrapperFromContentLibrary,
    PageErrorWrapperProps as PageErrorWrapperPropsFromContentLibrary,
    PageErrorWrapperStyles as PageErrorWrapperStylesFromContentLibrary,
    pageErrorWrapperStyles as pageErrorWrapperStylesFromContentLibrary,
} from "@insite/content-library/Components/PageErrorWrapper";

/**
 * @deprecated This interface has been moved to the content-library module and will be removed in a future release.
 */
export interface HasErrorStatusCode extends HasErrorStatusCodeFromContentLibrary {}
/**
 * @deprecated This interface has been moved to the content-library module and will be removed in a future release.
 */
export interface PageErrorWrapperProps extends PageErrorWrapperPropsFromContentLibrary {}
/**
 * @deprecated This interface has been moved to the content-library module and will be removed in a future release.
 */
export interface PageErrorWrapperStyles extends PageErrorWrapperStylesFromContentLibrary {}
/**
 * @deprecated This variable has been moved to the content-library module and will be removed in a future release.
 */
export const pageErrorWrapperStyles = pageErrorWrapperStylesFromContentLibrary;
/**
 * @deprecated This component has been moved to the content-library module and will be removed in a future release.
 */
export const PageErrorWrapper = PageErrorWrapperFromContentLibrary;
